//window.Vue = require('vue');

window.Vue = require('vue');
window.axios = require('axios');

//import Vue from "vue"
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/es';
import Form from './components/Reservation/Form.vue';
import Steps from './components/Reservation/Steps.vue'
import FinalCard from './components/Reservation/FinalCard.vue'

Vue.use(Element, { size: 'large', locale});

const app = new Vue({
    el: '.content',
    components: {
        'form-booking': Form,
        'steps': Steps,
        'final-card': FinalCard,
    },
});